import { Grid, makeStyles } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { updateParticipantPlanning } from '../../../../store/actions/participant/experience';
import { useDispatch } from 'react-redux';

const useStyles = makeStyles(() => ({
    container: {
        flex: 1,
        marginTop: 17,
        paddingLeft: 20,
        paddingRight: 20
    },
    header: {
        fontSize: '48px!important',
        fontFamily: 'Spartan-bold',
        fontWeight: 400,
        lineHeight: 1.3,
        letterSpacing: '0em',
        color: '#212D40',
        textAlign: 'center'
    },
    title: {
        fontFamily: 'roboto-regular',
        fontSize: 18,
        textAlign: 'center'
    },
    img: {
        width: 317,
        height: 204,
        cursor:'pointer',
        '@media (max-width: 1400px)': {
            width: 285,
            height: 166,
        },
    },
    checkTitle: {
        color: '#212D40',
        fontSize: 20,
        textAlign: 'center',
        fontWeight: 'bold'
    },
    item: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: 70,
        '@media (max-width: 1400px)': {
            marginTop: 20,
        },
    },
}));

function PlanningStep2() {

    const classes = useStyles();
    const dispatch = useDispatch();
    const history = useHistory();

    const onGoNextPage = (value: string) => {
        
        dispatch(updateParticipantPlanning('invited', value));
        
        if(value==="Yes"){
            history.push('/participant/planning/3')
        }else{
            history.push('/participant/planning/6')   
        }
    }

    return (
        <Grid container justifyContent={'center'} className={classes.container}>
            <Grid item lg={7} md={10} sm={12}>
                <p className={classes.header}>
                    Have you already been invited <br />
                    to participate in an experience?
                </p>

                <Grid container alignItems='center' justifyContent='center' spacing={1}>
                    <Grid item xs={12} md={6} className={classes.item} >
                        <img
                            onClick={() => onGoNextPage('Yes')}
                            className={classes.img}
                            alt="{img}"
                            onMouseOver={e => (e.currentTarget.src = "/assets/icons/participant/participant_yes2.svg")}
                            onMouseOut={e => e.currentTarget.src ="/assets/icons/participant/participant_yes.svg"}
                            src={"/assets/icons/participant/participant_yes.svg"}
                        />
                        <p className={classes.checkTitle}>Yes</p>
                    </Grid>

                    <Grid item xs={12} md={6} className={classes.item} >
                        <img
                            onClick={() => onGoNextPage('No')}
                            className={classes.img}
                            alt="{img}"
                            onMouseOver={e => (e.currentTarget.src = "/assets/icons/participant/participant_no2.svg")}
                            onMouseOut={e => e.currentTarget.src ="/assets/icons/participant/participant_no.svg"}
                            src={"/assets/icons/participant/participant_no.svg"}                            
                        />
                        <p className={classes.checkTitle}>No</p>
                    </Grid>

                </Grid>
            </Grid>
        </Grid>

    )
}

export default PlanningStep2;